import { setPlanState } from '@apps/shared/src/planSelect/actions';
import { Plan } from '@apps/shared/src/planSelect/types/plan';
import { toggleChangePlan } from '@apps/shared/src/providerSearch/actions';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectProps } from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';
import { connect } from 'react-redux';
import { IncompleteTheme } from '../../shared/types/theme';
import { RootState } from '../../store';

const Header = styled(Typography)(({ theme }) => ({
  ...(theme as IncompleteTheme).sidebar.headerText,
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  ...(theme as IncompleteTheme).selectMenuItem,
  display: 'block',
  padding: '12px 16px',
  minHeight: '48px',
}));

const StyledSelect = styled(Select)({
  width: '100%',
  '& .MuiSelect-select': {
    background: '#ffffff',
    border: '1px solid #E5EBF5',
    padding: '12px 16px',
  },
});

const mapStateToProps = ({ providerSearch, planSelect }: RootState): StateProps => ({
  isLoading: providerSearch.isLoadingProviderList,
  selectedPlanID: providerSearch.selectedPlanID,
  plans: planSelect.plans,
});

type StateProps = {
  isLoading: boolean;
  selectedPlanID?: string;
  plans: Plan[];
};

const mapDispatchToProps = {
  setPlanState,
  toggleChangePlan,
};

type Props = StateProps & typeof mapDispatchToProps;

const defaultPlanSelectLabel = 'No plan selected';
const defaultPlanSelectValue = '-1';

export function PlanSelectFilter({
  isLoading,
  selectedPlanID,
  plans,
  setPlanState,
  toggleChangePlan,
}: Props): JSX.Element {
  const handlePlanChange: SelectProps['onChange'] = e => {
    const plan = plans.find(plan => plan.id === e.target.value);
    if (plan) {
      setPlanState(plan);
      toggleChangePlan();
    }
  };

  if (plans.length < 2) return <></>;
  return (
    <div>
      <Header>Select a Plan</Header>
      <FormControl>
        <StyledSelect
          value={selectedPlanID || defaultPlanSelectValue}
          onChange={handlePlanChange}
          labelId="plan-select"
          disabled={isLoading}
          disableUnderline
        >
          {!selectedPlanID && (
            <StyledMenuItem value={defaultPlanSelectValue}>{defaultPlanSelectLabel}</StyledMenuItem>
          )}
          {plans.map(plan => (
            <StyledMenuItem value={plan.id} key={plan.id}>
              {plan.name}
            </StyledMenuItem>
          ))}
        </StyledSelect>
      </FormControl>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(PlanSelectFilter);
